
import React from 'react';
import { StorageService } from '../services/db';

export const FAQ: React.FC = () => {
  const faqs = StorageService.getFAQs();

  return (
    <div className="pt-24 pb-24 px-6 bg-white">
      <div className="max-w-3xl mx-auto py-24">
        <h1 className="text-5xl font-light mb-16 text-center uppercase tracking-tight">Support Center</h1>
        <div className="space-y-4">
          {faqs.map((faq) => (
            <details key={faq.id} className="group border border-stone-100 rounded-2xl overflow-hidden">
              <summary className="flex justify-between items-center p-6 cursor-pointer bg-stone-50 hover:bg-stone-100 transition-colors font-bold uppercase text-xs tracking-widest list-none">
                {faq.question}
                <span className="transition-transform group-open:rotate-180">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                </span>
              </summary>
              <div className="p-6 text-stone-600 leading-relaxed border-t border-stone-100 text-sm">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
};
